import { GET_POSITION_TYPES, GET_POSITION_TYPES_SUCCESS, GET_POSITION_TYPES_ERROR } from "./actionTypes";

export const getPositionTypes = (user) => {
  return {
    type: GET_POSITION_TYPES,
    payload: { user },
  };
};

export const getPositionTypesSuccess = (message, position_types) => {
  return {
    type: GET_POSITION_TYPES_SUCCESS,
    payload: { message, position_types },
  };
};

export const getPositionTypesError = (message) => {
  return {
    type: GET_POSITION_TYPES_ERROR,
    payload: message,
  };
};
